<template>
  <div id="problemList">
    <h1 class="mt-4" style="margin-bottom: 40px">Score Management</h1>
    <b-container>
      <b-form class="text-left" style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="filter"
            placeholder="Search Problem"
          ></b-form-input>
        </b-input-group>
      </b-form>
      <b-table
        :fields="fields"
        :items="items"
        hover
        outlined
        :sort-by.sync="sortBy"
        :filter="filter"
      >
        <template #cell(action)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <b-button size="sm" variant="primary" @click="toProblem(data.item.id)"
            >View</b-button
          >
          <b-button
            size="sm"
            variant="success"
            :disabled="exportDis[data.index]"
            style="margin-left: 10px"
            @click="exportScore(data); exportDis[data.index] = true"
            >{{ exportMsg[data.index] }}</b-button
          >
        </template>
      </b-table>
    </b-container>
  </div>
</template>
<script>
export default {
  created() {
    this.get_user_info();
    let self = this;
    const api = "/problem/";
    const access_token = localStorage.getItem("access_token");
    this.$http
      .get(api, {
        headers: {
          Authorization: "Bearer " + access_token,
        },
      })
      .then((response) => {
        for (let i in response.data) {
          response.data[i].score_end_date = response.data[
            i
          ].score_end_date.replace(/T/, " ");
          self.exportMsg.push("Export")
          self.exportDis.push(false)
        }
        this.items = response.data;
        this.origin_problems_num = response.data.length;
      });
  },
  beforeMount() {
    let self = this;
    this.$bus.$on("isAdmin", (event) => {
      self.is_admin = event.is_admin;
    });
  },
  mounted() {},
  beforeDestroy() {
    this.$bus.$off("isAdmin");
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "Problem ID",
          sortable: false,
        },
        {
          key: "title",
        },
        {
          key: "score_end_date",
          label: "Deadline",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      items: [],
      sortBy: "id",
      is_admin: undefined,
      probelm_id: undefined,
      problem_title: "",
      origin_problems_num: 0,
      userinfo: undefined,
      filter: "",
      csvURL: "",
      csvFilename: "",
      exportMsg: [],
      exportDis: [],
    };
  },
  methods: {
     toProblem(problem_id) {
      let self = this;
      this.$router.push({
        name: "Problem",
        params: {
          id: problem_id,
          userinfo: self.userinfo,
        },
      });
    },
    exportScore(data) {
      
      let api = "/judge/score/" + data.item.id;
      this.access_token = localStorage.getItem("access_token");
      let now = new Date();
      let offsetMs = now.getTimezoneOffset() * 60 * 1000;
      let dateLocal = new Date(now.getTime() - offsetMs);
      let str = dateLocal.toISOString().slice(0, 19);
      this.exportDis[data.index] = true;
      let self = this;
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(response.data);
          anchor.target = "_blank";
          anchor.download = str + "-Sysjudge-Score.csv";
          anchor.click();
          self.exportDis[data.index] = false;
        });
    },
    hideWarning() {
      this.$refs["warning"].hide();
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              location.replace("/");
            }
          }
        });
    },
    toComponent(c_name) {
      let userinfo = this.userinfo;
      this.$router.push({
        name: c_name,
        params: { userinfo },
      });
    },
  },
};
</script>

<style>
tr {
  vertical-align: middle;
}
</style>